export default __webpack_public_path__ + "static/media/phaphrom_img9.0f3d40be.webp";